import merge from "lodash.merge"
import deepclone from "lodash.clonedeep"
import Speedtest from "@frog/source/utility/Speedtest.js"
import Geometry from "@frog/source/utility/Geometry.js"
import Keyset from "@frog/source/utility/Keyset.js"

import Unit from "@frog/source/models/Unit.js"
import Delta from "@frog/source/models/Delta.js"

import stages from "@frog/source/data/stages.js"
import worlds from "@frog/source/data/worlds.js"
import encounters from "@frog/source/data/encounters.js" // imported for loading encounters.
import index from "@frog/source/data/index.js"
import skills from "@frog/source/data/skills.js"
import Step from "@frog/source/models/Step.js"

const MAX_INFLUENCE = 200 // TODO: this is duped from Unit.js

function fill(percentage, digits = 3) {
    if(digits == 0) {
        return ""
    }
    let string = ""
    string += Math.round(percentage * Math.pow(10, digits - 1))
    while(string.length < digits) {
        string = "0" + string
    }
    return string
}

export default class Stage {
    static load(stage) {
        if(stage.reference != undefined) {
            if(stages[stage.reference] == undefined) {
                throw "Could not find stage with reference " + stage.reference
            }

            // TODO: Even if the stage is referenced, it should merge
            // any overriding child properties on top of the reference!
            // But it should do it intelligently, like merging units instead
            // of replacing units?

            stage = deepclone(stages[stage.reference])
        }

        stage.units = Keyset.convert(stage.units)
        stage.units = Keyset.map(stage.units, (unit) => Unit.instantiate(unit))

        // TODO: THIS SHOULDN'T JUST NUKE IT, IT SHOULD MERGE
        // IT WITH ANY CHANGES...? THE PROTOSTAGE HAS DECLARED.
        // ALSO, WE SHOULD MOVE THIS TO A WORLD STATIC LOAD CLASS!
        if(stage.world.reference != undefined) {
            if(worlds[stage.world.reference] == undefined) {
                throw new Error("Could not find world with reference " + stage.world.reference)
            }
            let mergedWorld = deepclone(worlds[stage.world.reference])

            const alteredWorld = {"reference": stage.world.reference}
            mergedWorld = merge(mergedWorld, alteredWorld)

            // if(stage.world.terrain != undefined) {
            //     // const alteredTerrain = stage.world.terrain.map((terrain, key) => {
            //     //     if(terrain.position == undefined) {
            //     //         throw "Could not instantiate terrain without position"
            //     //     }
            //     //     terrain.position = terrain.position
            //     //     terrain.shape = terrain.shape || "block"
            //     //     terrain.z = terrain.position.z // AREN'T WE OBSOLETING THIS?
            //     //     terrain.key = terrain.key || terrain.position.x + "x" + terrain.position.y
            //     //     return terrain
            //     // })
            //     // console.log(alteredTerrain, mergedWorld)
            //     // mergedWorld.terrain = Keyset.merge(mergedWorld.terrain, alteredTerrain)
            // }
            // MERGE IN MORE PROPERTIES, BUT DEEPLY!!

            stage.world = mergedWorld
        }

        stage.turn = {"number": 0}
        stage.actionMark = 0
        stage.victory = stage.victory || {"type": "annihilate"} // TODO: qualify this as the player's victory?

        // TODO: Even if a stage is passed, search it for properties
        // that need to be deserialized or defaulted like base stats on units!
        // Or maybe the stage is defined but the map is a reference.

        return stage
    }
    static findUnitByPosition(stage, position) {
        return Keyset.find(stage.units, (unit) => {
            return Geometry.equals(unit.position, position)
        })
    }
    static hasSucceeded(affiliation, stage) {
        if(stage.victory.condition == "escape") {
            const units = Object.values(stage.units).filter((unit) => unit.affiliation == affiliation)
            const deadUnits = units.filter((unit) => unit.isDead == true)
            if(units.length == deadUnits.length) {
                const escapedUnits = units.filter((unit) => unit.hasEscaped == true)
                // console.log(escapedUnits)
                return escapedUnits.length > 0
            }
            return false
        }
        if(stage.victory.condition == "annihilate") {
            const aliveEnemyUnit = Keyset.find(stage.units, (unit) => {
                return unit.affiliation != affiliation
                    && unit.isDead != true
            })
            return aliveEnemyUnit == undefined
        }
    }
    static hasFailed(affiliation, stage) {
        const unit = Keyset.find(stage.units, (unit) => {
            return unit.affiliation == affiliation
                && unit.isDead != true
        })
        return unit == undefined
    }
    static hasFinishedTurn(affiliation, stage) {
        // const turntUnits = stage.units.filter((unit) => {
        //     return unit.affiliation == affiliation
        //         && unit.isDead != true
        // })
        // return turntUnits.every((unit) => {
        //     return unit.energy["move"] != true
        //         && unit.energy["invoke skill"] != true
        // })
    }
    static copy(alphastage) {
        const omegastage = {
            "units": Keyset.map(alphastage.units, (unit) => Unit.copy(unit)),
            "world": alphastage.world,
            "events": alphastage.events,
            "turn": {
                "number": alphastage.turn && alphastage.turn.number || 0
            },
            "actionMark": alphastage.actionMark,
            "victory": alphastage.victory,
        }
        // TODO: suport a less embedded test stubbing for skill id gen???
        if(alphastage.idgen !== undefined) {
            omegastage.idgen = alphastage.idgen
        }
        return omegastage
    }

    //////////////
    // SCORING //
    ////////////

    // static deltascore(alphastage, omegastage, affiliation) {
    //     const TARGET_PRIORITY = {
    //         "good": 100,
    //         "bad": 100,
    //         "none": 50,
    //     }
    //     const alphascore = Stage.score(alphastage, affiliation)
    //     const omegascore = Stage.score(omegastage, affiliation)
    //     let score = alphascore - omegascore
    //     // score = Math.min(1, score / MAX_SCORE)
    //
    //     return score
    // }

    // Does not (yet) set the action.score, just returns the score.
    // Lets you pass in a different stage from action.stage for predictive logic.
    static score({action, stage, affiliation}) {
        stage = stage || action.omegastage

        const scores = {}

        // INFLUENCES //
        let influenceScore = 0
        let influenceCount = 0
        if(action.influenceMap != undefined) {
            const omegaperformer = stage.units[action.performerKey]

            influenceScore = Stage.getinfluenceScore(action.influenceMap, omegaperformer.position)
            influenceCount += 1

            if(omegaperformer.effects != undefined) {
                Keyset.forEach(omegaperformer.effects, (effect) => {
                    if(effect.type == "trap") {
                        effect.positions.forEach((position) => {
                            influenceScore += Stage.getinfluenceScore(action.influenceMap, position)
                            influenceCount += 1
                        })
                    }
                })
            }
        }
        scores.influence = influenceScore / (MAX_INFLUENCE * influenceCount)

        // ACTION TYPE //

        scores.byActionType = 0
        if(action.type == "move through") {
            scores.byActionType = -1 // to be skipped!!
        } else if(action.type == "invoke skill") {
            scores.byActionType = 1
        } else if(action.type == "move") {
            scores.byActionType = 2
        }

        // PROGRESS TOWARDS GOALS //
        const progress = {}
        progress["bad"] = {"maxhealth": 0, "health": 0, "maxcount": 0, "count": 0}
        progress["good"] = {"maxhealth": 0, "health": 0, "maxcount": 0, "count": 0}
        Keyset.forEach(stage.units, (unit) => {
            progress[unit.affiliation] = progress[unit.affiliation] || {
                "maxhealth": 0, "health": 0, "maxcount": 0, "count": 0
            }
            progress[unit.affiliation].maxhealth += unit.maxhealth
            progress[unit.affiliation].health += unit.health
            progress[unit.affiliation].maxcount += 1
            progress[unit.affiliation].count += unit.isDead ? 0 : 1
        })
        scores["enemy"] = {
            "count": progress["good"].count / progress["good"].maxcount,
            "health": progress["good"].health / progress["good"].maxhealth,
            "progress": progress["good"],
        }
        scores["ally"] = {
            "count": progress["bad"].count / progress["bad"].maxcount,
            "health": progress["bad"].health / progress["bad"].maxhealth,
            "progress": progress["bad"],
        }
        if(progress["none"] != undefined) {
            scores["none"] = {
                "count": progress["none"].count / progress["none"].maxcount,
                "health": progress["none"].health / progress["none"].maxhealth,
                "progress": progress["none"],
            }
        }


        return scores
    }
    static getinfluenceScore(influenceMap, position) {
        return influenceMap[position.x + "x" + position.y]
    }
    static flattenActionMap(actionmap) {
        let actions = []
        Keyset.forEach(actionmap, (actionmaplist) => {
            actions = actions.concat(actionmaplist)
        })
        return actions
        // // By flattening a unit's action map, each possible position
        // // will have one and only one action, scored as the "best."
        // // In most cases, this is just different directions of approaching
        // // that same action type from different previous positions.
        // return Keyset.map(actionmap, (actionmaplist) => {
        //     return actionmaplist[0]
        // })
    }
    // Stage.isBetterScore(a, b)
    // returns true if (a) is a better score than (b)
    static isBetterScore(a, b) {
        if(a.enemy.count < b.enemy.count) return true
        if(a.enemy.count > b.enemy.count) return false
        if(a.enemy.health < b.enemy.health) return true
        if(a.enemy.health > b.enemy.health) return false

        if(a.ally.count > b.ally.count) return true
        if(a.ally.count < b.ally.count) return false
        if(a.ally.health > b.ally.health) return true
        if(a.ally.health < b.ally.health) return false // BOMBER AI POSITIONED THIS DIFFERENTLY

        if(a.influence > b.influence) return true
        if(a.influence < b.influence) return false

        if(a.none != undefined && b.none != undefined) {
            if(a.none.count < b.none.count) return true
            if(a.none.count > b.none.count) return false
            if(a.none.health < b.none.health) return true
            if(a.none.health > b.none.health) return false
        }

        if(a.byActionType > b.byActionType) return true
        if(a.byActionType < b.byActionType) return false
        // if(a.distance < b.distance) return -1
        // if(a.distance > b.distance) return +1

        // TODO: filter out a and b for .type == -1?
        // or just leave that to a separate isInvalidAction?
    }
    static isInvalidAction(action) {
        // TODO: why do we even keep these invalid actions around?
        if(action.type == "move through") {
            return true
        }
    }

    ////////////////
    // NEXT TURN //
    //////////////

    static calculateNextTurn(stage) {
        const {aiActions, steps} = Stage.getNonPlayerSteps(stage)

        stage.nextTurn = {
            "aiActions": aiActions,
            "steps": steps,
            "omegastage": steps[steps.length - 1].omegastage
        }
    }
    static getNonPlayerSteps(stage) {
        let steps = []

        steps = steps.concat(Stage.getEndOfTurnTileStpes(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        if(Stage.hasSucceeded("good", stage)) {
            steps = steps.concat(Stage.getSuccessSteps(stage))
            return {steps}
        } else if(Stage.hasFailed("good", stage)) {
            steps = steps.concat(Stage.getFailureSteps(stage))
            return {steps}
        }

        steps = steps.concat(Stage.getEndOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, stage.turn.number + ":end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getStartTurnSteps("bad", stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, stage.turn.number + ":start"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        const ai = Stage.getAiSteps("bad", stage)
        const aiActions = ai.actions // for returning from this function
        steps = steps.concat(ai.steps)
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEndOfTurnSkillSteps(stage))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        steps = steps.concat(Stage.getEventSteps(stage, stage.turn.number + ":end"))
        stage = steps.length > 0 ? steps[steps.length-1].omegastage : stage

        if(Stage.hasSucceeded("good", stage)) {
            steps = steps.concat(Stage.getSuccessSteps(stage))
            return {steps, aiActions}
        } else if(Stage.hasFailed("good", stage)) {
            steps = steps.concat(Stage.getFailureSteps(stage))
            return {steps, aiActions}
        }
        // if(Stage.hasSucceeded("bad", stage)) {
        //     steps = steps.concat(Stage.getFailureSteps(stage))
        //     return {steps, aiActions}
        // } else if(Stage.hasFailed("bad", stage)) {
        //     steps = steps.concat(Stage.getSuccessSteps(stage))
        //     return {steps, aiActions}
        // }

        steps = steps.concat(Stage.getStartTurnSteps("good", stage))
        stage = steps[steps.length-1].omegastage

        steps = steps.concat(Stage.getEventSteps(stage, stage.turn.number + ":start"))
        stage = steps[steps.length-1].omegastage

        // DECREASE EFFECT DURATION

        // actions = actions.concat(Stage.getEventActions(this.events[(this.turn.number + 2) + ":start"]))
        // actions = actions.concat(Stage.getWorldActions("good", shadowunits))

        return {steps, aiActions}
    }
    static getStartTurnSteps(affiliation, stage) {
        return [
            Step.instantiate({
                "type": "start turn",
                "alphastage": stage,
                "deltastages": [
                    {
                        "turn": {"number": +1},
                        "units": Keyset.map(stage.units, (unit) => {
                            return {
                                "energy": {"move": true, "invoke skill": true},
                            }
                        })
                    }
                ]
            })
        ]
    }
    static getEndOfTurnTileStpes(stage) {
        const steps = []
        let alphastage = stage
        if(stage.victory != undefined
        && stage.victory.condition == "escape") {
            stage.victory.positions.forEach((position) => {
                Keyset.forEach(alphastage.units, (unit) => {
                    if(unit.isDead != true
                    && Geometry.equals(unit.position, position)
                    && unit.affiliation == stage.victory.affiliation) {
                        const step = Step.instantiate({
                            "type": "escape",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "annotation": {"type": "escape", "startPosition": unit.position},
                                "units": {
                                    [unit.key]: {
                                        "isDead": true,
                                        "hasEscaped": true,
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    }
                })
            })
        }
        return steps
    }
    static getEndOfTurnSkillSteps(stage) {
        const steps = []
        let alphastage = stage

        // TODO: what is the order of unit and skills at the end-of-turn?
        Keyset.forEach(stage.units, (unit) => {
            Keyset.forEach(unit.effects, (effect, effectKey) => {
                const alphaunit = alphastage.units[unit.key]
                if(alphaunit.isDead == true) return
                const alphaeffect = alphaunit.effects[effectKey]
                if(alphaeffect.timer != undefined) {
                    if(alphaeffect.timer - 1 <= 0) {
                        if(alphaeffect.type == "fuse"
                        && alphaeffect.skillKey != undefined
                        && skills.get(alphaeffect.skillKey) != undefined) {
                            const step = skills.get(alphaeffect.skillKey).calculateStep({
                                "performerKey": alphaunit.key,
                                "effectKey": effectKey,
                                "position": alphaunit.position,
                                "stage": alphastage,
                            })
                            step.skillKey = alphaeffect.skillKey
                            step.type = "invoke skill"

                            Keyset.forEach(step.omegastage.units, (unit) => {
                                if(unit.health <= 0
                                && unit.isDead != true) {
                                    Step.add(step, {"units": {[unit.key]: {"isDead": true}}})
                                }
                            })

                            alphastage = step.omegastage
                            steps.push(step)
                        } else {
                            const step = Step.instantiate({
                                "type": "remove effect",
                                "alphastage": alphastage,
                                "deltastages": [{
                                    "units": {
                                        [alphaunit.key]: {
                                            "effects": {
                                                [effectKey]: undefined
                                            }
                                        }
                                    }
                                }]
                            })

                            alphastage = step.omegastage
                            steps.push(step)
                        }
                    } else {
                        const step = Step.instantiate({
                            "type": "decrement effect timer",
                            "alphastage": alphastage,
                            "deltastages": [{
                                "units": {
                                    [alphaunit.key]: {
                                        "effects": {
                                            [effectKey]: { // TODO: why isn't alphaeffect.key not defined :<
                                                "timer": alphaeffect.timer - 1,
                                            }
                                        }
                                    }
                                }
                            }]
                        })

                        alphastage = step.omegastage
                        steps.push(step)
                    }
                }
            })
            // alphaunit.skills.forEach((skillKey) => {
            //     const skill = skills.get(skillKey)
            //     if(skill != undefined
            //     && skill.type == "at-end-of-turn") {
            //         const step = Step.instantiate({
            //             "type": "invoke skill",
            //             "alphastage": stage,
            //             "deltastages": [skill.calculateDeltastages({
            //                 "performerKey": alphaunit.key,
            //                 "position": alphaunit.position,
            //                 "stage": alphastage,
            //             })
            //         })
            //
            //         alphastage = step.omegastage
            //         steps.push(step)
            //     }
            // })
        })

        return steps
    }

    static getAiSteps(affiliation, stage) {
        const turn = {
            "steps": [],
            "actions": {} // by unit key
        }

        const units = []
        Keyset.forEach(stage.units, (unit) => {
            if(unit.affiliation == "bad"
            && unit.isDead != true) {
                units.push(unit)
            }
        })

        let alphastage = stage
        units.forEach((unit) => {
            const actionmap = Unit.calculateActions(unit.key, alphastage)
            let actions = Stage.flattenActionMap(actionmap)

            if(actions.length == 0) return

            let bestAction = undefined
            actions.forEach((action) => {
                if(Stage.isInvalidAction(action)) {
                    return action
                }

                // TODO: This should be far less verbose... Pull in the Step.js class?? as Sequence.js?
                action.predictiveSteps = action.steps.concat(Stage.getEndOfTurnSkillSteps(action.omegastage))
                action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage
                action.predictiveSteps = action.predictiveSteps.concat(Stage.getEndOfTurnSkillSteps(action.predictiveOmegastage))
                action.predictiveOmegastage = action.predictiveSteps[action.predictiveSteps.length-1].omegastage

                action.score = Stage.score({
                    "stage": action.omegastage,
                    // "stage": action.predictiveOmegastage, // hey headsup this is breaking the trap effect ai. // BOMBER AI
                    "action": action,
                    "affiliation": "bad",
                })

                if(bestAction == undefined
                || Stage.isBetterScore(action.score, bestAction.score)) {
                    bestAction = action
                }

                return action
            })
            if(bestAction != undefined) {
                turn.actions[unit.key] = {"action": bestAction, "actionmap": actionmap}
                turn.steps = turn.steps.concat(bestAction.steps)
                alphastage = turn.steps[turn.steps.length-1].omegastage
            }
        })

        return turn

        // TODO: Address the hangover of returning actions alongside steps.
        // We need them to render the enemy ui. We really just use action type
        // and action position. We are currently hurting because we're not
        // returning the entire action map (to show enemy range). We need to
        // eventually include order of actions as well, to match the order
        // of steps, so we can maybe animate the enemy intention ui with some
        // slight order-of-operations delay in how it renders out.

        // RECENT //

        // const affiliatedUnits = {}
        // let steps = []
        // let alphastage = stage
        // Keyset.forEach(stage.units, (unit) => {
        //     const alphaunit = alphastage.units[unit.key]
        //     if(alphaunit.affiliation == "bad"
        //     && alphaunit.isDead != true) {
        //         const actionmap = Unit.calculateActions(unit.key, alphastage)
        //         const action = Unit.getBestAction(actionmap)
        //         steps = steps.concat(action.steps)
        //         affiliatedUnits[unit.key] = {action, actionmap}
        //
        //         if(action != undefined) {
        //             alphastage = action.omegastage
        //         }
        //     }
        // })
        // // TODO: ONCe WE HAVE THE BEST ACTION, WE CAN PROBABLY DUMP ALLLLL THE OTHER POSSIBILITIES AS USELESS.
        // return {"affiliatedUnits": affiliatedUnits, "affiliatedSteps": steps}

        // OLDER //

        // this.influence[affiliation] = this.getInfluence(affiliation, shadowunits)
        // TODO: uuuuh if there is any meaningful state change in stage vs
        // alphastagewithheavycomputation, then we need to recompute here.

        // // this is so wasteful, given that
        // // alphastage at the start of this getnonplyaeractions process should have already
        // // computed all of this. or most of this (it doesn't have the start of turn state
        // // changes like effects wearing off)
        // // UUH IS THIS STILL TRUE I REFACTORED IT SO IT ONLY CALCULATES ONCE
        //
        // Keyset.forEach(stage.units, (unit) => {
        //     if(unit.affiliation == affiliation && unit.isDead != true) {
        //         steps = steps.concat(unit.bestAction.steps)
        //         // THIS DOES NOT RESPECT THE ORDER OF THE
        //         // BEST ACTIONS, SO IF YOU EVER CHANGE IT
        //         // SO UNIT ORDER IS DYNAMIC, THIS MUST BE
        //         // RESTRUCTURED ACCORDINGLY
        //     }
        // })
    }
    static getFailureSteps(stage) {
        let steps = [
            {
                "type": "failure modal",
                "alphastage": stage, "omegastage": stage,
            },
        ]
        steps = steps.concat(Stage.getEventSteps(stage, "failure"))
        return steps
    }
    static getSuccessSteps(stage) {
        let steps = [
            {
                "type": "success modal",
                "alphastage": stage, "omegastage": stage,
            },
        ]
        steps = steps.concat(Stage.getEventSteps(stage, "success"))
        return steps
    }
    static getEventSteps(stage, eventKey) {
        if(stage == undefined
        || stage.events == undefined
        || stage.events[eventKey] == undefined) {
            return []
        }
        let alphastage = stage
        return stage.events[eventKey].map((event) => {
            let step = {}
            step.alphastage = alphastage
            if(event.type == "spawn") {
                step.type = "spawn"
                if(Stage.findUnitByPosition(alphastage, event.unit.position) == undefined) {
                    const unit = Unit.instantiate(event.unit)
                    unit.mode = "create"
                    step.deltastages = [
                        {"units": {[unit.key]: unit}}
                    ]
                }
            }
            if(event.type == "navigate") { // TODO: this is effectively duped from the data/encounters.js
                step.type = "navigate"
                step.path = event.path
            }
            if(event.type == "load encounter") {
                step.type = "load encounter"
                if(encounters[event.encounterSlug] == undefined) {
                    throw new Error("Could not find encounter " + event.encounterSlug)
                }
                step.encounter = encounters[event.encounterSlug]
                step.encounter = JSON.parse(JSON.stringify(step.encounter))
                // TODO: how to save the current party in the scripting?
                // this is hardcoded for now.
                // TODO: Also, this is currently OVERWRITING the encoutner for everyone, not JUST
                // this one "campaign".
                // step.encounter = Keyset.merge({}, encounters[event.encounterSlug])
                // step.encounter.stage = Stage.copy(step.encounter.stage)
                if(event.isPreservingState == true) {
                    Keyset.forEach(step.encounter.stage.units, (nextUnit) => {
                        if(nextUnit.affiliation == "good") {
                            const currentUnit = Keyset.find(stage.units, (unit) => unit.reference == nextUnit.reference)
                            if(currentUnit != undefined) {
                                nextUnit.health = currentUnit.health
                                if(currentUnit.hasEscaped != true) {
                                    nextUnit.isDead = true
                                }
                            }
                        }
                    })
                }
                step.deltastages = []
            }
            step = Step.instantiate(step)
            alphastage = step.omegastage
            return step
        })
    }

    ////////////////
    // YOUR TURN //
    //////////////

    static calculateActions(stage) {
        const mark = Speedtest.mark("Actions", "Stage.calculateActions")

        if(stage.hasPerformedActionCalculation == true) {
            return
        }

        Keyset.forEach(stage.units, (unit) => {
            if(unit.affiliation == "good") {
                unit.actionmap = Unit.calculateActions(unit.key, stage)
                // // We're now calculating this just-in-time for when you hover over this actionmap option.
                // Object.values(unit.actionmap).forEach((actionlist) => actionlist.forEach((action) => {
                //     Stage.calculateNextTurn(action.omegastage)
                // }))
            }
        })
        Stage.calculateNextTurn(stage)

        stage.hasPerformedActionCalculation = true

        mark()

        return stage
    }
}
